import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import AnimatedFriend from '../game/AnimatedFriend';
import Critter from '../game/Critter';
import { getCreatureOffsets } from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import CountFishScreen from './CountFishScreen';
import FontKeys from '../FontKeys';
import LocalizationUIAssets from '../Localization-UIAssets';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class TitleScreen extends Phaser.Scene {
  static get KEY() { return 'TitleScreen'; }

  constructor() {
    super({ key: TitleScreen.KEY });
  }

  init() {
    this.title = null;
    this.critter = null;

    this.octopus = null;

    this.btnGo = null;

    this.music = null;
  }

  create() {

    this.btnGo = this.add.container(this.scale.width / 2, this.scale.height - 35);
    ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._BtnGo, this.btnGo);
    ABCyaPhaser.Text.addText(0, 0, 56, 0xffffff, FontKeys._bpreplaybold, ABCyaPhaser.Localization.instance.getLocalizedString('go'), this.btnGo);

    this.btnGo.height = this.btnGo.getBounds().height;
    this.btnGo.setAlpha(0);
    ABCyaPhaser.Container.setContainerInteractive(this.btnGo);

    this.btnGo.y -= this.btnGo.height / 2;
    ABCyaPhaser.Tweens.addTween(this.btnGo, 600, { alpha: 1 }, Phaser.Math.Easing.Linear);

    this.createGoBtnPulseTween();

    this.critter = new Critter(this, { x: 111,y: 222 }, 'Fish', 2);
    this.critter.x = 333;
    this.critter.y = 444;
    this.critter.initializeHover();
    this.critter.doAnimatedSwim();
    this.add.existing(this.critter);
    this.critter.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.toggleFishHighlight, this);

    this.octopusContainer = this.add.container();
    const offsets = getCreatureOffsets('Friend1');
    this.octopus = new AnimatedFriend(this, 'Friend', 1, offsets);
    this.octopusContainer.add(this.octopus);
    this.octopusContainer.scale = 0;
    this.octopusContainer.x = this.scale.width / 2 + 50;
    this.octopusContainer.y = this.scale.height - 400;

    this.title = ABCyaPhaser.Images.addImage(this.scale.width / 2, this.scale.height / 2 - 100, LocalizationUIAssets._Title, this, ABCyaPhaser.Images.LOCALIZATION_ATLAS).setScale(0);
    this.titleVO = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => this.titleVO.destroy());
    ABCyaPhaser.Tweens.addTween(this.title, 1400, { scale: 1 }, Phaser.Math.Easing.Quadratic.Out, () => ABCyaPhaser.Audio.playSound(LocalizationSoundAssetKeys._counting_fish_00, this.titleVO));

    ABCyaPhaser.Tweens.addTween(this.octopusContainer, 500, { delay: 1400, scale: 1, x: this.octopusContainer.x + 44, y: this.octopusContainer.y + 46 }, Phaser.Math.Easing.Quadratic.Out);

    this.btnGo.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onClickGo, this);

    this.music = ABCyaPhaser.Audio.createSound(this);
    ABCyaPhaser.Audio.playSound(SoundAssetKeys._fish_music, this.music, 1, true);
  }

  async createGoBtnPulseTween() {
    await ABCyaPhaser.Async.waitForTween(ABCyaPhaser.Tweens.addTween(this.btnGo, 840, { delay: 1200, scale: 0.8, completeDelay: 120 }, Phaser.Math.Easing.Quadratic.In));
    await ABCyaPhaser.Async.waitForTween(ABCyaPhaser.Tweens.addTween(this.btnGo, 800, { scale: 1, completeDelay: 3740 }, Phaser.Math.Easing.Quadratic.Out));

    // stop repeating once this scene is no longer active
    if (this.scene.isActive()) this.createGoBtnPulseTween();
  }

  toggleFishHighlight () {
    if (this.critter.isHighlighted) {
      this.critter.unhighlight();
    }
    else {
      this.critter.highlight();
    }
  }

  onClickGo () {
    this.music.destroy();
    this.scene.start(CountFishScreen.KEY);
  }

  update(time, delta) {
    this.critter.tick(delta / 1000);
    this.octopus.tick(delta / 1000);
  }
}